var UserAction;
(function (UserAction) {
    UserAction["POST_LOAD"] = "post_load";
    UserAction["POST_LORRY"] = "post_lorry";
    UserAction["LOAD_BID"] = "load_bid";
    UserAction["LORRY_BID"] = "lorry_bid";
    UserAction["SEND_C2C_REQUEST"] = "send_c2c_request";
    UserAction["SEND_CONNECTION_REQUEST"] = "send_connection_request";
    UserAction["SIM_TRACKING_REQUEST"] = "simTracking";
})(UserAction || (UserAction = {}));
var UserActionRequiredResponse;
(function (UserActionRequiredResponse) {
    UserActionRequiredResponse["VERIFY_AADHAAR"] = "aadhaar_verification";
    UserActionRequiredResponse["VERIFY_PAN"] = "pan_verification";
    UserActionRequiredResponse["VERIFY_GST"] = "gst_verification";
    UserActionRequiredResponse["BUY_MEMBERSHIP"] = "buy_membership";
    UserActionRequiredResponse["TOP_UP_MEMBERSHIP"] = "topup_membership";
    UserActionRequiredResponse["UPGRADE_MEMBERSHIP"] = "upgrade_membership";
    UserActionRequiredResponse["DAILY_MEMBERSHIP_LIMIT_EXHAUSTED"] = "daily_membership_limit_exhausted";
    UserActionRequiredResponse["EDIT_COMPANY_NAME"] = "edit_company_name";
    UserActionRequiredResponse["MEMBERSHIP_EXPIRED"] = "membership_expired";
    UserActionRequiredResponse["CLEAR_CASHBACK_COINS"] = "clear_cashback_coins";
})(UserActionRequiredResponse || (UserActionRequiredResponse = {}));

export { UserAction, UserActionRequiredResponse };
//# sourceMappingURL=userAction.js.map
